import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => changeLanguage('es')}
        className={`text-2xl transition-opacity ${i18n.language === 'es' ? 'opacity-100' : 'opacity-40'} hover:opacity-100`}
        title="Español"
      >
        🇪🇸
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={`text-2xl transition-opacity ${i18n.language === 'en' ? 'opacity-100' : 'opacity-40'} hover:opacity-100`}
        title="English"
      >
        🇺🇸
      </button>
    </div>
  );
}
